/* eslint-disable react-hooks/exhaustive-deps */
import Axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { DIV } from 'src/components/CustomStyledComponents';
import NavbarHeader from 'src/components/header/NavbarHeader';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import useLoading from 'src/hooks/useLoading';
import { imagenSeguro } from 'src/pipes/imagenes';
import { setCotizacion } from 'src/reducers/Cotizacion/cotizacion.actions';
import { guardarLead } from 'src/services';
import { urlGetProductos, urlSetProductoCotizacion } from 'src/services/urls';

const HomePage = ({ cotizacion, idCotizacion }: any) => {
  const [productos, setProductos] = useState([]);
  const history = useHistory();

  const { values, setLoading, setSecundario, resetLoading } = useLoading(true);

  const dispatch = useDispatch();

  const { addWarningToast } = useCustomToast();

  const init = useCallback(async () => {
    setLoading(true);
    setSecundario('Buscando productos...');
    const body = {
      flujo: cotizacion.flujoPlugin,
      canal: cotizacion.canal,
      empBroker: cotizacion.broker,
      empAplica: cotizacion.empAplica,
      empAseguradora: cotizacion.broker,
      tieneInicioSesion: cotizacion?.producto?.tieneInicioSesion ?? false,
    };
    try {
      const { data } = await Axios.post(urlGetProductos, JSON.stringify(body));

      console.log(data);
      if (data.transaccion) {
        setProductos(data.microseguros);
      }
    } catch (error) { }
    resetLoading();
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  const onClick = (producto: any) => async () => {
    guardarLead(idCotizacion, `PREVIEW_PRODUCTO__CLICK_ADQUIRIR`);
    setSecundario('Buscando información del producto...');

    const body = { idCotizacion, segCodCore: producto.codigoCore };
    const { data } = await Axios.post(urlSetProductoCotizacion, JSON.stringify(body));

    if (data.transaccion) {
      dispatch(setCotizacion(data.data));
    } else {
      return addWarningToast('HA OCURRIDO UN PROBLEMA AL AGREGAR EL PRODUCTO');
    }

    history.push(`/preview/${idCotizacion}/${producto.id}`);
  };
  return (
    <LoadingWrapper {...values}>
      <DIV stylePath="home.globalStyles" className="container-fluid container-page">
        <NavbarHeader />

        <div className="container__titulo row justify-content-center mt-5">
          <div className="col-12 col-md-8 ml-2 ml-md-4 align-self-center">
            <h5 id="titulo">Elige el plan que mejor se adapte a ti</h5>
          </div>
        </div>

        {productos?.map((producto) => (
          <div className="row justify-content-around pointer my-4 " key={producto.id}>
            <div
              className=" container__producto col-12 col-md-8 col-lg-6 card shadow"
              style={{ minHeight: '100px', borderRadius: '0.6rem' }}
            >
              <div className="row" onClick={onClick(producto)}>
                <div className="col-4 text-center align-self-center my-3">
                  <img
                    style={{ maxHeight: '100px' }}
                    className="img-fluid"
                    src={imagenSeguro(producto)}
                    alt={producto.nombre}
                  />
                </div>
                <div className="col-7 col-md-7 border-left border-info my-3">
                  <h5 className="producto__nombre font-weight-bold">{producto.nombre}</h5>
                  <div>
                    <p className="producto__descripcion">{producto.descripcion}</p>
                  </div>
                  {!!producto?.valoresPagar?.total && producto?.valoresPagar?.total !== "0.00" &&
                    <p className="producto__precio align-self-baseline font-weight-bold">
                      Adquiérelo desde {cotizacion?.moneda?.signo} {producto?.valoresPagar?.total} {cotizacion?.moneda?.sigla}
                    </p>
                  }
                </div>
                <div className="col-1 col-md-1 align-self-center my-3">
                  <i className="pi pi-chevron-right" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </DIV>
    </LoadingWrapper>
  );
};

export default withCotizacion(HomePage);
